import { render } from "./MyFooter.vue?vue&type=template&id=0882d918&scoped=true"
const script = {}

import "./MyFooter.vue?vue&type=style&index=0&id=0882d918&lang=scss&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.29_vue@3.5.29_webpack@5.105.4/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0882d918"]])

export default __exports__